import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main-area">
        <div className="flag-bar" />
        <Topbar onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
